<template>
  <div class="_wrapper" :class="{ 'is-shop': displayMode === 'shop' }">
    <section class="container mt50 flex-full" v-if="displayMode === 'food'">
      <div v-if="promotions.length" class="row center-xs promotions-items px15">
        <div class="background-wrap relative mb20 between-xs" v-for="(promotion, index) in promotions" :key="index">
          <a :href="promotion.link ? promotion.link : ''">
            <div class="background" :style="{'background-image': 'url(' + promotion.image + ')'}">
              <div class="wrap">
                <div class="title" v-html="promotion.title"></div>
                <div class="time"> {{ promotion.time }} </div>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div v-else>
        <p class="h3 mb50 mt50 align-center"> {{ $t('There are no shares here yet') }} </p>
      </div>
    </section>
    <div class="block mt20" v-else-if="displayMode === 'shop'">
      <div class="discount-block mt20" v-if="promotions.length">
        <div class="discount-block-promo"
             v-for="(promotion, index) in promotions"
             :key="index"
        >
          <a :href="promotion.link ? promotion.link : ''">
            <div class="background" :style="{ 'background-image': `url(${promotion.image})` }">
              <div class="wrap">
                <div class="title" v-html="promotion.title"></div>
                <div class="time"> {{ promotion.time }} </div>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div v-else>
        <p class="h3 mb50 mt50 align-center"> {{ $t('There are no shares here yet') }} </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  // displayMode (which template branch renders) reads currentPartner; App.vue's
  // store watcher doesn't fire for the initial route.
  async asyncData ({ store, route }) {
    if (!route.params.store) {
      return
    }
    await store.dispatch('partners/ensureCurrentPartner', { code: route.params.store, locationCode: route.params.locationCode })
  },
  computed: {
    ...mapGetters({
      currentPartner: 'partners/getCurrentPartner',
      displayMode: 'partners/getCurrentPartnerDisplayMode',
      locations: 'locations/getLocations'
    }),
    promotions () {
      return this.currentPartner && this.currentPartner.promotions ? this.currentPartner.promotions.filter(p => p.type === 'discount') : []
    }
  },
  metaInfo () {
    if (!this.currentPartner) {
      return {}
    }
    const location = this.locations.find(location => location.code === this.currentPartner.location_code)
    const city = location ? ` у м.${location.name}` : ''
    return {
      title: `Акції та знижки ${this.currentPartner.title}${city}`,
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: `Актуальні акції та знижки ${this.currentPartner.title}${city}. Замовляйте з доставкою від Korzyna.`
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
._wrapper {
  width: 100%;

  &.is-shop {
    width: 850px;

    @media only screen and (max-width: 1200px) {
      width: 654px;
    }

    @media only screen and (max-width: 991px) {
      width: 722px;
    }

    @media only screen and (max-width: 768px) {
      width: 530px;
    }

    @media only screen and (max-width: 576px) {
      width: calc(100% - 30px);
      padding: 0 15px;
    }
  }
}

.block {
  width: 850px;

  @media only screen and (max-width: 1200px) {
    width: 654px;
  }

  @media only screen and (max-width: 991px) {
    width: 722px;
  }

  @media only screen and (max-width: 768px) {
    width: 530px;
  }

  @media only screen and (max-width: 576px) {
    width: 100%;
  }
}

.discount-block {
  display: flex;
  flex-wrap: wrap;

  &-promo {
    width: 345px;
    height: 167px;

    margin: 0 20px 20px 0;
  }
}

.h3{
  padding-top: 100px;
  padding-bottom: 100px;
}
.promotions-items{
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.background-wrap{
  width: 345px;
  border-radius: 10px;
  overflow: hidden;
  @media (max-width: 375px){
    width: 304px;
  }
  @media (min-width: 769px){
    margin-left: 10px;
    margin-right: 10px;
  }
}
.background{
  background-position: right top;
  background-repeat: no-repeat;
  height: 167px;
  position: relative;
  text-align: left;

  .title{
    font-size: 16px;
    color: #fff;
    padding-left: 10px;
    margin-top: auto;
    span{
      display: inline;
      font-family: 'TTNorms Bold', sans-serif;
    }
  }
  .time{
    padding-left: 10px;
    font-size: 12px;
    color: #fff;
    opacity: 0.6;
    margin-top: auto;
    margin-bottom: 20px;
  }
  .wrap:after{
    content:'';
    position: absolute;
    left: 100%;
    top: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 83.5px 0 83.5px 20px;
    border-color: transparent transparent transparent #000000;
  }
  .wrap{
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 0;
    top: 0;
    width: 170px;
    height: 100%;
    background-color: black;
  }
}
</style>
<style lang="scss">
.background{
  .title{
    span{
      display: inline;
      font-family: 'TTNorms Bold', sans-serif;
    }
  }
}
</style>
